import { transitionGetters } from '@/store/modules/transition/routines'

export default {
  [transitionGetters.TRANSITION_CONFIG]: state => state
}
